
import { useQuery } from '../../../lib/hooks/useQuery';
import { useMutation } from '../../../lib/hooks/useMutation';
import { productsApi } from '../../../lib/api/products';
import { Product, ProductFilters } from '../../../lib/types';

export function useProducts(filters?: ProductFilters) {
  return useQuery(
    ['products', JSON.stringify(filters)],
    () => productsApi.getProducts(filters)
  );
}

export function useProduct(id: string) {
  return useQuery(
    ['products', id],
    () => productsApi.getById<Product>(id),
    { enabled: !!id }
  );
}

export function useProductSearch() {
  return useMutation(
    (searchTerm: string) => productsApi.searchProducts(searchTerm)
  );
}

export function useCreateProduct() {
  return useMutation(
    (productData: Partial<Product>) => productsApi.create<Product>(productData),
    {
      onSuccess: () => {
        // Invalidate products cache
        console.log('Product created successfully');
      }
    }
  );
}

export function useUpdateProduct() {
  return useMutation(
    ({ id, data }: { id: string; data: Partial<Product> }) => 
      productsApi.update<Product>(id, data),
    {
      onSuccess: () => {
        // Invalidate products cache
        console.log('Product updated successfully');
      }
    }
  );
}

export function useDeleteProduct() {
  return useMutation(
    (id: string) => productsApi.delete(id),
    {
      onSuccess: () => {
        // Invalidate products cache
        console.log('Product deleted successfully');
      }
    }
  );
}

export function useProductsByCategory(category: string) {
  return useQuery(
    ['products', 'category', category],
    () => productsApi.getProductsByCategory(category),
    { enabled: !!category }
  );
}
